export default {
  // General
  skip: 'Skip',
  back: 'Back',
  next: 'Next',
  finish: 'Finish',
  close: 'Close',
  
  // Welcome
  welcome: {
    title: 'Welcome to YouCRM! 🎉',
    subtitle: 'Would you like a quick tour of the application?',
    start: 'Yes, let\'s start!',
    skipAll: 'Skip tour',
    description: 'We\'ll show you the main features in just a few minutes.'
  },
  
  // Dashboard Tour
  dashboard: {
    title: 'Dashboard Tour',
    steps: {
      welcome: {
        title: '📊 Dashboard',
        content: 'This is your main page where you get an overview of the most important data and statistics.'
      },
      stats: {
        title: '📈 Statistics',
        content: 'Here you can see real-time summaries of customers, projects, and tasks.'
      },
      quickActions: {
        title: '⚡ Quick Actions',
        content: 'Quick access to frequently used functions with one click.'
      },
      recentActivity: {
        title: '🕐 Recent Activity',
        content: 'Track the latest events and changes in your system.'
      }
    }
  },
  
  // Flow Builder Tour
  flowBuilder: {
    title: 'Flow Builder Tour',
    steps: {
      welcome: {
        title: '🎨 Flow Builder',
        content: 'Visual automation tool where you can build complex workflows without coding.'
      },
      canvas: {
        title: '🖼️ Canvas',
        content: 'Build your flows here using drag & drop. Drag nodes and connect them together!'
      },
      sidebar: {
        title: '🧩 Node Palette',
        content: 'Drag nodes onto the canvas. Organized by categories: Trigger, Action, Logic, etc.'
      },
      properties: {
        title: '⚙️ Properties',
        content: 'Click on a node for detailed settings. Configure its behavior here.'
      },
      toolbar: {
        title: '🛠️ Toolbar',
        content: 'Save, run, schedule, and other operations. Use the ⚡ button to execute your flow!'
      },
      terminal: {
        title: '📟 Terminal',
        content: 'Real-time execution logs. Track what happens during flow execution.'
      }
    }
  },
  
  // Customers Tour
  customers: {
    title: 'Customers Tour',
    steps: {
      welcome: {
        title: '👥 Customer Management',
        content: 'Manage your customers, contacts, and all important information in one place.'
      },
      list: {
        title: '📋 Customer List',
        content: 'Search, filter, and sort through customers. Click a row for details.'
      },
      add: {
        title: '➕ New Customer',
        content: 'Add a new customer with the + button. Fill in basic information and save.'
      },
      search: {
        title: '🔍 Search',
        content: 'Quick search by name, email, or company. Filters in real-time!'
      },
      filters: {
        title: '🎯 Filters',
        content: 'Filter by status, tags, or custom fields. Combine multiple filters!'
      }
    }
  },
  
  // Help Button
  helpButton: {
    tooltip: 'Restart tour',
    label: 'Help'
  },
  
  // Progress
  progress: {
    step: 'step',
    of: 'of',
    completed: 'Tour completed! 🎉'
  }
};
